import { IMediaEndpoint } from '@/types/feed.types';

enum MediaType {
  ImagePoster = 'image-poster',
  ImagePosterLandscape = 'image-poster-landscape',
  VideoHLS = 'video-hls',
  VideoDASH = 'video-dash',
  FNHLS = 'fn-hls',
  FNDASH = 'fn-dash',
}

export interface MediaUrls {
  posterUrl: string;
  videoUrl: string;
  posterLandscapeUrl?: string;
}

export function getMediaUrls(
  mediaDataOrPromise?: IMediaEndpoint[] | Promise<IMediaEndpoint[]>,
  isAsync: boolean = false,
): MediaUrls | Promise<MediaUrls> {
  const processMediaData = (mediaData: IMediaEndpoint[]): MediaUrls => {
    const getMediaUrl = (mediaTypes: MediaType[]): string => {
      for (const mediaType of mediaTypes) {
        const mediaItem = mediaData.find((item) => item.type === mediaType);
        if (mediaItem?.url) return mediaItem.url;
      }
      return '';
    };

    const videoTypes: MediaType[] = [MediaType.VideoHLS, MediaType.FNHLS];

    return {
      posterUrl: getMediaUrl([MediaType.ImagePoster]),
      posterLandscapeUrl: getMediaUrl([MediaType.ImagePosterLandscape]),
      videoUrl: getMediaUrl(videoTypes),
    };
  };

  if (isAsync) {
    return (async () => {
      const mediaData = await Promise.resolve(mediaDataOrPromise ?? []);
      return processMediaData(mediaData);
    })();
  } else {
    if (!Array.isArray(mediaDataOrPromise)) {
      return { posterUrl: '', posterLandscapeUrl: '', videoUrl: '' };
    }
    return processMediaData(mediaDataOrPromise);
  }
}
